import { type ReactNode, useState } from 'react';
import { ChevronDown, ChevronRight, AlertTriangle } from 'lucide-react';
import { FieldSelect } from '@/components/ui/field-input';

const STATUSES: { value: string; label: string }[] = [
  { value: '', label: 'Default (foto → test, sin foto → verifying)' },
  { value: 'verifying', label: 'verifying — pendiente de foto' },
  { value: 'test', label: 'test — en prueba' },
  { value: 'healthy', label: 'healthy — saltar verificación + test' },
];

type Props = {
  value: string;
  onChange: (v: string) => void;
};

function ToggleRow({
  open,
  onClick,
}: {
  open: boolean;
  onClick: () => void;
}): ReactNode {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-xs text-xs uppercase tracking-wider text-text-tertiary hover:text-text-secondary"
    >
      {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
      Avanzado
    </button>
  );
}

function Warning(): ReactNode {
  return (
    <div className="flex items-start gap-xs rounded-md border border-warning/30 bg-warning/5 px-sm py-1.5 text-xs text-warning">
      <AlertTriangle size={12} className="mt-0.5 shrink-0" />
      <span>
        Forzar el estado salta el flujo normal de verificación. Solo úsalo si
        sabes lo que estás haciendo.
      </span>
    </div>
  );
}

export function AdvancedSection({ value, onChange }: Props): ReactNode {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-sm border-t border-white/[0.04] pt-sm">
      <ToggleRow open={open} onClick={() => setOpen(!open)} />
      {open && (
        <div className="space-y-sm">
          <Warning />
          <FieldSelect value={value} onChange={(e) => onChange(e.target.value)}>
            {STATUSES.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </FieldSelect>
        </div>
      )}
    </div>
  );
}
